export default {
  addAnotherRule: {
    id: 'display_pricing_rules_add_another_rule',
    defaultMessage: 'Add another rule',
  },
  dailyUpdate: {
    id: 'pricing_tool_daily_update_new',
    defaultMessage: 'Update prices every 24 hours on listings without BuyBox',
  },
  dailyUpdateDescription: {
    id: 'pricing_tool_daily_update_description',
    defaultMessage:
      "This automatic update won't impact your listings with the BuyBox.",
  },
  withoutBackBoxesInfo: {
    id: 'pricing_tool-only_without_backboxes_info',
    defaultMessage: 'This will effect all listings, with and without BackBox',
  },
}
